import React, { useState, useCallback, useEffect } from 'react';
import { Box, Alert } from '@mui/material';
import HaiInputPanel from '../components/HaiInputPanel';
import Controls from '../components/Controls';
import AgarihaiResult from '../components/AgarihaiResult';
import { fetchAgarihais } from '../api';

const AgarihaiCalculatePage = ({ setPageTitle }) => {
  // --- 状態管理 ---
  const [tehai, setTehai] = useState([]);
  const [furos, setFuros] = useState([[], [], [], []]);
  const [agarihais, setAgarihais] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [panelKey, setPanelKey] = useState(Date.now());

  // AppBarのタイトルを設定
  useEffect(() => {
    setPageTitle('アガリ牌計算');
  }, [setPageTitle]);

  /**
   * HaiInputPanelから状態の変更を受け取るコールバック
   */
  const handleStateChange = useCallback(({ tehai, furos }) => {
    setTehai(tehai);
    setFuros(furos);
  }, []);

  /**
   * すべての牌と計算結果をクリアする関数
   */
  const handleClear = () => {
    setTehai([]);
    setFuros([[], [], [], []]);
    setAgarihais(null);
    setError('');
    setPanelKey(Date.now()); // keyを更新してHaiInputPanelを再マウントさせる
  };

  /**
   * バックエンドAPIを呼び出してアガリ牌を計算する関数
   */
  const handleCalculate = async () => {
    setIsLoading(true);
    setError('');
    setAgarihais(null);
    try {
      const result = await fetchAgarihais(tehai, furos);
      setAgarihais(result.agariHais);
    } catch (err) {
      // axiosのエラーレスポンス、フロントエンドのバリデーションエラー、その他のエラーを適切に処理
      setError(err.response?.data?.detail || err.message || '計算中にエラーが発生しました。');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <HaiInputPanel key={panelKey} onStateChange={handleStateChange}>
        <Controls onClear={handleClear} onPredict={handleCalculate} isLoading={isLoading} />
      </HaiInputPanel>

      <Box sx={{ mt: 4 }}>
        {error && <Alert severity="error">{error}</Alert>}
        {agarihais && <AgarihaiResult agarihais={agarihais} />}
      </Box>
    </>
  );
};

export default AgarihaiCalculatePage;